const CustomerNotFound = () => <div>Customer ID Not found</div>

export default CustomerNotFound
